module.exports = __webpack_public_path__ + "static/media/tierra.3bcc28f6.png";